
const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      title: 'ご相談・お問い合わせ',
      description: 'お電話またはフォームからお気軽にご相談ください',
      icon: 'ri-phone-line'
    },
    {
      number: '02',
      title: 'ヒアリング・ご提案',
      description: 'ご要望を詳しくお聞きし、最適なプランをご提案',
      icon: 'ri-discuss-line'
    },
    {
      number: '03',
      title: 'ご契約・お手続き',
      description: '必要な書類作成から契約まで丁寧にサポート',
      icon: 'ri-file-text-line'
    },
    {
      number: '04',
      title: 'アフターフォロー',
      description: 'ご契約後も継続的にサポートいたします',
      icon: 'ri-customer-service-line'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            ご利用の流れ
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="relative mb-6">
                <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${step.icon} text-white text-2xl`}></i>
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                  <span className="text-blue-600 font-bold text-sm">{step.number}</span>
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-10 left-full w-full h-0.5 bg-blue-200 transform -translate-x-1/2"></div>
                )}
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
